import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import Navbar from './components/Navbar'

import DepartmentAccordion from './components/DepartmentAccordion'
import Footer from './components/Footer'

import LoadingScreen from './components/LoadingScreen'

function App() {
  const [isLoading, setIsLoading] = useState(true)
  const [isVisible, setIsVisible] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Check if mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)
    
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false)
      setIsVisible(true)
    }, 2000)

    return () => {
      clearTimeout(timer)
      window.removeEventListener('resize', checkMobile)
    }
  }, [])

  if (isLoading) {
    return <LoadingScreen />
  }

  // Disable animations on mobile
  const MotionDiv = isMobile ? 'div' : motion.div

  return (
    <div className="relative min-h-screen overflow-x-hidden">
      {/* Main Content */}
      <AnimatePresence>
        {isVisible && (
          <MotionDiv
            initial={isMobile ? {} : { opacity: 0 }}
            animate={isMobile ? {} : { opacity: 1 }}
            transition={isMobile ? {} : { duration: 0.8 }}
            className="relative z-10"
          >
            <Navbar />
            
            <main className="container mx-auto px-4 py-4 sm:py-8 pt-[calc(12.96rem+5vh-1rem)] sm:pt-[calc(11.52rem+5vh-1rem)]">
              <MotionDiv
                initial={isMobile ? {} : { opacity: 0, y: 50 }}
                animate={isMobile ? {} : { opacity: 1, y: 0 }}
                transition={isMobile ? {} : { delay: 0.3, duration: 0.8 }}
              >
                <DepartmentAccordion />
              </MotionDiv>
            </main>
            
            <Footer />
          </MotionDiv>
        )}
      </AnimatePresence>
    </div>
  )
}

export default App
